import React, { useState } from "react";
import "./PaintCalculator.css";

const PaintCalculator = () => {
  const [walls, setWalls] = useState([
    { height: "", width: "" },
    { height: "", width: "" },
  ]);
  const handleInputChange = (index, field, value) => {
    const updated = [...walls];
    updated[index][field] = value;
    setWalls(updated);
  };
  const addWall = () => {
    setWalls([...walls, { height: "", width: "" }]);
  };
  const removeWall = (index) => {
    if (walls.length > 2) {
      setWalls(walls.filter((_, i) => i !== index));
    }
  };
  const calculatePaint = () => {
    let totalArea = walls.reduce((sum, wall) => {
      return (
        sum + (parseFloat(wall.height) || 0) * (parseFloat(wall.width) || 0)
      );
    }, 0);
    return (totalArea / 10).toFixed(2);
  };
  return (
    <div className={`pc-wrapper ${walls.length > 2 ? "hide-blur" : ""}`}>
      <div className="pc-card">
        <div className="pc-header">
          <h2>Paint Calculator</h2>
          <p>
            Paint calculator simplifies your project by accurately measuring the
            needed paint, making painting easier.
          </p>
        </div>
        <div className="pc-body">
          {walls.map((wall, index) => (
            <div className="pc-row" key={index}>
              <div className="pc-input-group">
                <label>Height of the area (m):</label>
                <input
                  type="number"
                  placeholder="Enter height"
                  value={wall.height}
                  onChange={(e) =>
                    handleInputChange(index, "height", e.target.value)
                  }
                />
              </div>
              <div className="pc-input-group">
                <label>Width of the area (m):</label>
                <input
                  type="number"
                  placeholder="Enter width"
                  value={wall.width}
                  onChange={(e) =>
                    handleInputChange(index, "width", e.target.value)
                  }
                />
              </div>
            </div>
          ))}
          <div className="pc-btn-row">
            <button
              className="remove3-btn"
              onClick={() => removeWall(walls.length - 1)}
              disabled={walls.length <= 2}
            >
              Remove
            </button>
            <button className="add-btn" onClick={addWall}>
              Add New Wall
            </button>
          </div>
          <div className="paint-result">
            Quantity(Ltr) of Paint Needed: {calculatePaint()} Ltr
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaintCalculator;
